export default {
  // Categories
  "cat.shoes": "Shoes",
  "cat.hoodies": "Hoodies/Sweaters",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jackets",
  "cat.pants": "Pants/Shorts",
  "cat.headwear": "Headwear",
  "cat.sets": "Sets",
  "cat.underwear": "Underwear/Underpants",
  "cat.jersey": "Jersey",
  "cat.accessories": "Accessories",
  "cat.bags": "Bags",
  "cat.belts": "Belts",
  "cat.perfumes": "Perfumes",
  "cat.other": "Other Stuff",
};